import memoize from 'lodash.memoize';
import { isMatchPointValid, isNamedPlaceHolder } from './match-point-regex.js';

/**
 * 管理Named PlaceHolder的匹配
 * @public
 */
class NamedPlaceHolder {
    constructor() {
        this.getMatchPoint = (key) => {
            const matchPoints = this.namedPlaceholders.filter(placeholder => isMatchPointValid(placeholder, key));
            if (matchPoints.length > 1) {
                throw new Error(`Ambiguous match points found for key ${key}, match points ${matchPoints.join(', ')}`);
            }
            return matchPoints[0];
        };
        /**
         * 获得matchPoint Memoized 的key
         * @internal
         * @privateRemarks
         * 为了避免对已有schema重复正则，引入memoized。可是bind会引入新的namedPlaceholders
         * 使得memoized结果失效。所以修改cachekey
         */
        this.matchPointMemoizedCacheKey = (...args) => this.namedPlaceholders.length + args[0];
        /**
         * 获取某一name是否真实对应一个matchPoint
         * @internal
         * @privateRemarks
         * memoize是因为每个正则消耗时间太长，总计节省40%时间
         * @param key - 配置 key
         */
        this.getMemorizedMatchPoint = memoize(this.getMatchPoint, this.matchPointMemoizedCacheKey);
        this.namedPlaceholders = [];
    }
    /**
     * 将named parameter添加到数据组
     * @param namedPlaceholder - named placeholder字符串
     */
    addMatchPoint(namedPlaceholder) {
        if (isNamedPlaceHolder(namedPlaceholder) && !this.namedPlaceholders.includes(namedPlaceholder)) {
            this.namedPlaceholders.push(namedPlaceholder);
        }
    }
}

export { NamedPlaceHolder };
//# sourceMappingURL=named-placeholder.js.map
